import {
    objectNode,
    type ObjectNode, type ObjectProperties,
    updateObject,
} from '@/lib/threeScene/nodes/object';
import { Group } from 'three';
import { type StopHandle } from '@/util';
import type { SceneContext } from '@/lib/threeScene/SceneContext';
import type { NodeId } from '@/lib/threeScene/nodeId';

export type GroupNode = ObjectNode<'group'>;

export function groupNode(id: NodeId, properties?: ObjectProperties<GroupNode>): GroupNode {
    return objectNode('group', id, properties);
}

export function updateGroup(context: SceneContext, node: GroupNode): StopHandle {
    const group = new Group();
    return updateObject(context, node, group);
}
